import MethodRepository from "@/repositories/tuevs/MethodRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'method',
    namespaced: true,
    state: makeState(),
    getters: makeGetters(),
    mutations: makeMutations(),
    actions: {
        async listOne ({ commit, state }, id) {
            commit('setLoading', true)
            await MethodRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.data.method)
            })
            commit('setLoading', false)
        },
        async listAll ({ commit, state }, params) {
            commit('setLoading', true)
            await MethodRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data)
                commit('setPagination', {
                    ...state.pagination,
                    total: response.data.total
                })
            })
            commit('setLoading', false)
        },
        async search ({ commit, state }, params) {
            commit('setLoading', true)
            await MethodRepository.fetchAll(params).then(response => {
                if (response.data.data.length > 0){
                    const array = response.data.data
                    commit('setAll', Object.values([...state.list, ...array].reduce((acc,cur)=>Object.assign(acc,{[cur.id]:cur}),{})))
                }
            })
            commit('setLoading', false)
        }
    }
}
